import React from "react";
import { cn } from "@/lib/utils";

export type TimeRangeType = "today" | "7d" | "30d" | "90d" | "all";

interface PartnerTimeFilterProps {
  value: TimeRangeType;
  onChange: (range: TimeRangeType) => void;
  className?: string;
  compact?: boolean;
}

const ranges: Array<{ value: TimeRangeType; label: string; short: string }> = [
  { value: "today", label: "Σήμερα", short: "Σήμερα" },
  { value: "7d", label: "7 ημέρες", short: "7η" },
  { value: "30d", label: "30 ημέρες", short: "30η" },
  { value: "90d", label: "90 ημέρες", short: "90η" },
  { value: "all", label: "Όλη η περίοδος", short: "Όλα" },
];

const PartnerTimeFilter: React.FC<PartnerTimeFilterProps> = ({ value, onChange, className }) => (
  <div
    className={cn("flex max-w-full gap-1 overflow-x-auto rounded-xl border border-slate-200 bg-white p-1", className)}
    role="group"
    aria-label="Χρονική περίοδος"
  >
    {ranges.map((range) => (
      <button
        key={range.value}
        type="button"
        onClick={() => onChange(range.value)}
        className={cn(
          "h-10 shrink-0 rounded-lg px-3 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500",
          value === range.value ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100",
        )}
      >
        <span className="sm:hidden">{range.short}</span>
        <span className="hidden sm:inline">{range.label}</span>
      </button>
    ))}
  </div>
);

export default PartnerTimeFilter;
